import React, { useState, useEffect } from "react";
import api from "../api";
import { Login } from "./Login";
import { Shell } from "./Shell";
import { ForcePasswordChange } from "../auth/ForcePasswordChange";

export default function Mobile() {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!api.getToken()) { setLoading(false); return; }
    api.get('/auth/me').then(d => setMe(d)).catch(() => { api.logout(); }).finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const onExpired = () => { setMe(null); setLoading(false); };
    window.addEventListener('hrms-auth-expired', onExpired);
    return () => window.removeEventListener('hrms-auth-expired', onExpired);
  }, []);

  const onLogin = () => {
    setLoading(true);
    api.get('/auth/me').then(d => setMe(d)).finally(() => setLoading(false));
  };
  const onLogout = () => {
    api.logout();
    setMe(null);
    window.location.assign('/m');
  };
  // Re-fetch after a self-service change (e.g. profile photo) so the new
  // value shows up without a full app reload.
  const refreshMe = () => api.get('/auth/me').then(setMe).catch(() => {});

  if (loading) return <div className="flex items-center justify-center min-h-screen bg-bg text-t3">Loading…</div>;
  if (!me) return <Login onLogin={onLogin} />;
  // Same must_change_password gate as desktop — blocks Shell rendering
  // until the user picks a real password.
  if (me.user?.must_change_password) return (
    <ForcePasswordChange
      username={me.user?.username}
      onDone={() => api.get('/auth/me').then(setMe)}
      onLogout={onLogout}
    />
  );
  return <Shell me={me} onLogout={onLogout} onRefreshMe={refreshMe} />;
}
